import React from 'react';

const AboutUs = () => {
    return (
        <div>

            <div className='about-container-header'>
                <h1>  About Us </h1>
            </div>

            <div className="about-container">

                <div className='about-card'>
                    <div className='about-card-title'>
                        <h1>Who we are : Why BANCO CONNECT ?</h1>
                    </div>

                    <div className='about-card-body'>
                        <p>
                        Over the decades, ONLINE BANCO CONNECT (<strong>OBC</strong>) has transformed into a 
                        progressive and modern Offshore Service Provider (<strong>OSP</strong>). We are supported 
                        by a study financial base,  led by a strong and stable management as proven by 
                        our clients who have stood with us over the years. 
                        Today, we offer a full range of financial services to help our customers 
                        build and manage their finances. 
                        </p>
                        <p>
                        Banco Connect is not a Banking Institution. We are just an Offshore Service 
                        Provider (<strong>OSP</strong>), serving as a gateway between institutions and customers. 
                        </p>
                        <p>
                        Banco Connect is a standard platform for Online Connections, that act as a gateway or mediator 
                        between institutions and customers worldwide. 
                        As derived from his name in Spanish and Portuguese, BANCO means BENCH. 
                        However, it's a digital and virtual Bench on which all Customers sit and 
                        we help them to get Connected through our gateway over the World.
                        </p>

                    </div>
                </div>

                <div className='about-card'>
                    <div className='about-card-title'>
                        <h1>OUR VISION</h1>
                    </div>

                    <div className='about-card-body'>

                        <p> To be the best <strong>OSP</strong> for our customers. </p>
                    </div>
                </div>

                <div className='about-card'>
                    <div className='about-card-title'>
                        <h1> OUR PURPOSE </h1>
                    </div>

                    <div className='about-card-body'>
                        <p>
                            To back the world ambition in the offshore
                            Innovation and client focus enables Banco Connect to provide
                            personalized, simple, smart services for better offshore account banking.
                        </p>
                    </div>
                </div>

                <div className='about-card'>
                    <div className='about-card-title'>
                        <h1> OUR VALUES </h1>
                    </div>

                    <div className='about-card-body'>

                        <p>
                            We define it into four letters : C.O.D.E
                            <ul>
                                <li><span className='about-card-body-value'>Collaboration :</span>   One platform together now.</li>
                                <li> <span className='about-card-body-value' > Ownership :</span>  What we say, we do.</li>
                                <li> <span className='about-card-body-value'>Delivery :</span>  Drive flawless execution</li>
                                <li> <span className='about-card-body-value' >Excellence :</span>  Win together through service excellence</li>
                            </ul>
                        </p>
                    </div>
                </div>

                <div className='about-card'>
                    <div className='about-card-title'>
                        <h1> VALUES PROPOSITIONS </h1>
                    </div>

                    <div className='about-card-body'>
                        <p>
                            <ul>
                                <li>We win together by delivering results that make a real impact for our customers.</li>
                                <li>We win together by developing the talent into the world. </li>
                                <li>We win together as one team.</li>
                            </ul>
                        </p>

                    </div>
                </div>

            </div>

        </div>
    );
};

export default AboutUs;